import Swal from "sweetalert2";

export const Error = (errorCode, message) => {
  if (errorCode === 404) {
    return Swal.fire({
      title: "Oops!",
      text: message,
      icon: "error",
      showConfirmButton: false,
      showCancelButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  } else if (errorCode === 422) {
    return Swal.fire({
      title: "Oops!",
      text: message,
      icon: "error",
      showConfirmButton: false,
      showCancelButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  } else if (errorCode === 401) {
    sessionStorage.clear();
    localStorage.clear();
    Swal.fire({
      title: "Oops!",
      text: "Unauthenticated Access",
      icon: "error",
      showConfirmButton: false,
      showCancelButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
    // window.location = "/PageNotFound";
  } else if (errorCode === 123) {
    return Swal.fire({
      // title: "error",
      title: message,
      icon: "warning",
      showConfirmButton: false,
      showCancelButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  } else {
    return Swal.fire({
      title: "Oops!",
      text: "Something went wrong",
      icon: "error",
      showConfirmButton: false,
      showCancelButton: false,
      timer: 5000,
      timerProgressBar: true,
    });
  }
};
